import i18n from "../../../../../constants/i18n";
import getKhattabatAiMessagesStore from "../../../../../stores/khattabat-stores/ai-messages";
import { TSelectionPages } from "../../../../../Types";
import Et3Image from "../../../../../core/et3-Image";
import ET3Div from "../../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../../core/et3-enhanced-render";
import Et3Text from "../../../../../core/et3-text";
import Et3Margin from "../../../../../core/et3-ui/ET3Margin";

const SendButton = withLiteObserverAndTheme<{ pageType: TSelectionPages }>(
  (props) => {
    const { theme, pageType } = props;
    const { colors, unitX } = theme;
    const shouldSend = getKhattabatAiMessagesStore().shouldSendMessages.get();
    const isSendingMessage =
      getKhattabatAiMessagesStore().isSendingMessages.get();

    return (
      <ET3Div
        width={1510}
        height={40}
        alignItems={"center"}
        fDirection={"column"}
        style={{}}
        color={""}
        justifyContent={"center"}
        withShadow={false}
        isExtendable={true}
        isScrollable={false}
        onClick={() => {}}
      >
        <ET3Div
          width={108}
          height={40}
          alignItems={"center"}
          fDirection={"row"}
          justifyContent={"center"}
          style={{
            backgroundColor: shouldSend
              ? colors.all.bondiBlue
              : colors.all.gray,
            borderRadius: 41 * unitX,
            cursor: "pointer"
          }}
          color={""}
          withShadow={false}
          isExtendable={false}
          isScrollable={false}
          onClick={() =>
            shouldSend
              ? getKhattabatAiMessagesStore().sendAllMessages(pageType)
              : null
          }
        >
          <Et3Text
            fontFamily={"LIGHT"}
            fontSize={18}
            isSpan={false}
            text={isSendingMessage ? i18n.get("SENDING") : i18n.get("SEND")}
            style={{}}
            color={colors.all.white}
          />
          {isSendingMessage ? null : (
            <>
              <Et3Margin left={1} right={1} top={0} bottom={0} />
              <Et3Image
                type="LOCAL"
                alt={i18n.get("USER")}
                imageName={"send"}
                size={18}
                onClick={() => {}}
                style={{}}
              />
            </>
          )}
        </ET3Div>
      </ET3Div>
    );
  }
);

export default SendButton;
